import { Info } from 'lucide-react';
import { InfoBox } from '../../../../components/InfoBox';
import { useUnsafeTranslation } from '../../../../i18next';
import { FlexContainer } from '../../../../layout/Flex';
import { printTz } from '../../../../services/time';

export const UserTimezoneHandlingInfoBox = ({ tz }: { tz: string }) => {
  const { t } = useUnsafeTranslation();
  return (
    <InfoBox fullWidth>
      <FlexContainer alignItems="flex-start">
        <Info size={20} />
        <div>
          {t(
            `Default timezone ({{ tz }}) will be used for users without timezone data`,
            {
              tz: printTz(tz)
            }
          )}
        </div>
      </FlexContainer>
    </InfoBox>
  );
};
